import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "active-actions-table" };
const _hoisted_2 = { class: "active-actions-table__header" };
const _hoisted_3 = { class: "active-actions-table__header__description" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "icon mr--4 icon-config-14px" }, null, -1);
const _hoisted_6 = {
    key: 1,
    class: "active-actions-table__header__buttons-priority"
};
const _hoisted_7 = {
    key: 0,
    class: "el-table__column"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_11 = {
    key: 0,
    class: "active-actions-table__cell"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = ["onClick", "src", "data-hover"];
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = { key: 2 };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("span", { class: "active-actions-table__dropdown__button" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" })
], -1);
const _hoisted_17 = {
    key: 0,
    class: "el-table__column"
};
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("i", { class: "icon mr--4 icon-hamburger" }, null, -1);
const _hoisted_21 = {
    key: 1,
    class: "active-actions-table__cell"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = ["onClick", "src", "data-hover"];
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("span", { class: "active-actions-table__dropdown__button" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" })
], -1);
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { vDragable } from 'element-plus-table-dragable';
import router from '@/router';
import i18n from '@/i18n';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import ModalConfirmEditActions from '@/features/CampaignsManagement/components/ModalConfirmEditActions.vue';
import { fetchActionsList } from '../data/fetchActionsList';
import { postActivateDeactivate } from '../data/postActivateDeactivate';
import { updatePriority } from '../data/putPriority';
import { useRedirect } from '../composables';
import Lottie from 'lottie-web';
import loadingAnimation from '@/assets/json/loading-ai-insights.json';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import AiButton from '@/components/_atoms/AIButton.vue';
import SendBalance from './SendBalance.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActiveActionsTable',
    props: {
        selectedTab: {}
    },
    emits: ['isEditPriority'],
    setup(__props, { emit }) {
        const props = __props;
        const state = reactive({
            loading: false,
            columns: [],
            tableHeader: [],
            hasError: false,
            id: 'active-actions-table',
            tableData: [],
            defaultTableData: [],
            isEditTable: false,
            isVisibleConfirmEditPriorityModal: false,
            showLoadingAiInsights: false,
            lastSentDate: '',
        });
        const animationContainer = ref(null);
        const table = ref(null);
        const store = useStore();
        const toast = useToast();
        const { redirectToParticipantsPage, redirectToEditActionPage } = useRedirect();
        const dragOptions = [
            {
                selector: 'tbody',
                option: {
                    animation: 150,
                    onEnd: (event) => {
                        const clonedTableData = [...state.tableData];
                        const movedAction = clonedTableData.splice(event.oldIndex, 1)[0];
                        clonedTableData.splice(event.newIndex, 0, movedAction);
                        const updatedTableData = clonedTableData.map((action, index) => ({ ...action, priority: index + 1 }));
                        state.tableData = updatedTableData;
                    },
                },
            },
        ];
        const isDataUnchanged = computed(() => {
            if (state.loading)
                return true;
            return JSON.stringify(state.tableData) === JSON.stringify(state.defaultTableData);
        });
        const isEditPriorityConfirmationModalTriggered = computed(() => {
            return store.state.campaignsManagement.isConfirmEditPriorityModalOpen;
        });
        const isActionPerformanceEnabled = computed(() => {
            return store.getters.getEnabledActionPerformance;
        });
        const getEnableAutomaticAction = computed(() => {
            return store.getters.getEnableAutomaticAction;
        });
        const shouldShowNoMessageTooltip = (row) => {
            // Check if the campaign action explicitly has no message content configured
            // false means action has campaign, but at least one campaign has no message
            // true means action has campaigns with messages
            // null means action has no campaign at all
            return row.hasMessageCampaign === false;
        };
        const enableTableEditMode = () => {
            state.isEditTable = true;
            emit('isEditPriority', true);
        };
        const cancelTableEditMode = () => {
            state.isEditTable = false;
            state.tableData = state.defaultTableData;
            emit('isEditPriority', false);
        };
        const editConfirmationModalHasBeenClosed = () => {
            state.isVisibleConfirmEditPriorityModal = false;
            store.dispatch('campaignsManagement/setOpenConfirmEditPriorityModal', false);
        };
        const saveTablePriorityEdits = () => {
            editConfirmationModalHasBeenClosed();
            state.isEditTable = false;
            state.loading = true;
            const actionIds = state.tableData.map(action => action.id).join(';');
            const params = {
                actions: actionIds,
                campaigns_order: 'priority',
            };
            updatePriority(params).then(isSuccessful => {
                if (isSuccessful) {
                    toast.success(i18n.global.t('campaigns-management.active-actions.edited'), {
                        timeout: 5000,
                    });
                    fetchDataTable();
                }
                else {
                    toast.error(i18n.global.t('campaigns-management.active-actions.error'), {
                        timeout: 5000,
                    });
                    state.loading = false;
                }
                emit('isEditPriority', false);
            });
        };
        const finishAiInsightsAnimation = (animationInstance) => {
            state.showLoadingAiInsights = false;
            document.body.style.overflow = '';
            animationInstance.destroy('AiInsights');
        };
        const startAiInsightsAnimation = () => {
            const bodyEl = document.body;
            state.showLoadingAiInsights = true;
            const animationInstance = Lottie.loadAnimation({
                name: 'AiInsights',
                container: animationContainer.value,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: loadingAnimation,
            });
            bodyEl.style.overflow = 'hidden';
            const ANIMATION_DURATION = 6000;
            setTimeout(() => {
                finishAiInsightsAnimation(animationInstance);
            }, ANIMATION_DURATION);
            useMixpanelConfig('view_oto_campaigns');
        };
        const sortTableDataByPerformance = () => {
            if (!state.tableData)
                return;
            startAiInsightsAnimation();
            const SORT_DELAY_TIME = 5000;
            setTimeout(() => {
                state.tableData = state.tableData
                    .toSorted((a, b) => {
                    const performanceA = Number(a.performance.split(' - ')[0]);
                    const performanceB = Number(b.performance.split(' - ')[0]);
                    if (performanceA !== performanceB)
                        return performanceA - performanceB;
                    const revenueA = a.revenuePerContact;
                    const revenueB = b.revenuePerContact;
                    return revenueB - revenueA;
                })
                    .map((action, index) => ({ ...action, priority: index + 1 }));
            }, SORT_DELAY_TIME);
        };
        const fetchDataTable = async () => {
            state.loading = true;
            const params = {
                enabled: 1,
            };
            await fetchActionsList(params).then(response => {
                if (response?.success) {
                    state.tableData = response.data;
                    state.defaultTableData = response.data;
                    state.tableHeader = response.columns;
                    state.tableHeader.push({ label: '', key: 'actions' });
                    state.lastSentDate = response.lastSentDate;
                }
                else {
                    state.hasError = true;
                }
                state.loading = false;
            });
        };
        const deactivateAction = (action) => {
            state.loading = true;
            const params = {
                actionId: action.id,
                enabled: 0,
            };
            postActivateDeactivate(params).then(isSuccessful => {
                if (isSuccessful) {
                    toast.success(i18n.global.t('campaigns-management.active-actions.deactive'), {
                        timeout: 5000,
                    });
                    fetchDataTable();
                }
                else {
                    state.hasError = true;
                    state.loading = false;
                }
            });
        };
        const getStatusPerformance = (name) => {
            if (name) {
                const hyphenPosition = name.indexOf('-');
                return hyphenPosition !== -1 ? name.slice(hyphenPosition + 1).trim() : name;
            }
        };
        const getColumnWidth = (columnKey) => {
            const width = {
                priority: 55,
                name: 268,
                period: 150,
                actions: 35,
                performance: 200,
            };
            return width[columnKey];
        };
        watch(() => props.selectedTab, () => {
            if (props.selectedTab === 'active') {
                fetchDataTable();
            }
        }, { immediate: true });
        watch(isEditPriorityConfirmationModalTriggered, () => {
            state.isVisibleConfirmEditPriorityModal = isEditPriorityConfirmationModalTriggered.value;
        });
        watch(isDataUnchanged, () => {
            store.dispatch('campaignsManagement/setPriorityDataModified', isDataUnchanged.value);
        }, { deep: true });
        onMounted(() => {
            if (router.currentRoute.value.query?.edit) {
                enableTableEditMode();
            }
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_router_link = _resolveComponent("router-link");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(ModalConfirmEditActions, {
                    id: "confirm-edit-priorities",
                    "is-visible": state.isVisibleConfirmEditPriorityModal,
                    onSave: saveTablePriorityEdits,
                    onHide: editConfirmationModalHasBeenClosed
                }, null, 8, ["is-visible"]),
                _createElementVNode("div", _hoisted_1, [
                    (getEnableAutomaticAction.value)
                        ? (_openBlock(), _createBlock(SendBalance, {
                            key: 0,
                            "last-sent-date": state.lastSentDate
                        }, null, 8, ["last-sent-date"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('campaigns-management.active-actions.description')), 1),
                        (!state.isEditTable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: !state.tableData.length,
                                onClick: enableTableEditMode,
                                class: "btn btn-outline-ctx-primary active-actions-table__header__btn-priority"
                            }, [
                                _hoisted_5,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('campaigns-management.active-actions.edit-priority')), 1)
                            ], 8, _hoisted_4))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("button", {
                                    onClick: cancelTableEditMode,
                                    class: "btn btn-outline-ctx-primary"
                                }, _toDisplayString(_ctx.$t('campaigns-management.active-actions.cancel')), 1),
                                _withDirectives(_createVNode(AiButton, {
                                    label: _ctx.$t('campaigns-management.active-actions.ai-insights'),
                                    onOnClick: sortTableDataByPerformance,
                                    class: "active-actions-table__ai-insights"
                                }, null, 8, ["label"]), [
                                    [_vShow, isActionPerformanceEnabled.value]
                                ]),
                                _createElementVNode("button", {
                                    onClick: saveTablePriorityEdits,
                                    class: "btn"
                                }, _toDisplayString(_ctx.$t('campaigns-management.active-actions.save')), 1)
                            ]))
                    ]),
                    (!state.loading)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!state.isEditTable)
                                ? (_openBlock(), _createBlock(_component_el_table, {
                                    key: 0,
                                    data: state.tableData,
                                    style: { "width": "100%" },
                                    "empty-text": ' ',
                                    class: _normalizeClass({ 'active-actions-table--blocked': !state.tableData.length }),
                                    ref_key: "table",
                                    ref: table,
                                    "scrollbar-always-on": false
                                }, {
                                    empty: _withCtx(() => [
                                        _createVNode(InfoCard, {
                                            ref: "message-error",
                                            error: state.hasError && !state.loading
                                        }, null, 8, ["error"]),
                                        (state.loading)
                                            ? (_openBlock(), _createBlock(BaseLoader, { key: 0 }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.tableHeader, (column, index) => {
                                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                                key: index,
                                                prop: column.key,
                                                label: column.label,
                                                "min-width": getColumnWidth(column.key)
                                            }, {
                                                header: _withCtx(() => [
                                                    (column.key === 'performance')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                            _createElementVNode("img", {
                                                                class: "el-table__column__ai-icon",
                                                                src: require('@/assets/svgs/black-star-icon.svg')
                                                            }, null, 8, _hoisted_8),
                                                            _createElementVNode("label", null, _toDisplayString(column.label), 1),
                                                            _createVNode(_component_el_popover, {
                                                                effect: "dark",
                                                                trigger: "hover",
                                                                placement: "top",
                                                                width: 370
                                                            }, {
                                                                reference: _withCtx(() => [
                                                                    _hoisted_10
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("p", {
                                                                        innerHTML: _ctx.$t('campaigns-management.ia-insights.tooltips.column')
                                                                    }, null, 8, _hoisted_9)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                default: _withCtx((scope) => [
                                                    (column.key === 'name')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                            _createVNode(_component_router_link, {
                                                                title: scope.row.action,
                                                                to: `/campaigns/campaigns/edit/${scope.row.id}`,
                                                                class: "active-actions-table__name"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(scope.row.action), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["title", "to"]),
                                                            (shouldShowNoMessageTooltip(scope.row))
                                                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                                    key: 0,
                                                                    placement: "top",
                                                                    content: _ctx.$t('campaigns-management.active-actions.no_message'),
                                                                    "popper-class": "active-actions-table__tooltip"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("img", {
                                                                            class: "active-actions-table__no-message-icon",
                                                                            src: require(`@/assets/svgs/information.svg`)
                                                                        }, null, 8, _hoisted_12)
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["content"]))
                                                                : _createCommentVNode("", true),
                                                            (scope.row.campaignsApproval)
                                                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                                    key: 1,
                                                                    placement: "top",
                                                                    content: _ctx.$t('campaigns-management.active-actions.pending', {
                                                                        participating: scope.row.campaignsApproval.participating,
                                                                        total: scope.row.campaignsApproval.total,
                                                                    }),
                                                                    "popper-class": "active-actions-table__tooltip"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("img", {
                                                                            class: "active-actions-table__approval-icon",
                                                                            onClick: ($event) => (_unref(redirectToParticipantsPage)(scope.row)),
                                                                            src: require(`@/assets/svgs/Store.svg`),
                                                                            "data-hover": require(`@/assets/svgs/StoreOmni.svg`)
                                                                        }, null, 8, _hoisted_13)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["content"]))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (column.key === 'performance')
                                                        ? (_openBlock(), _createBlock(_component_el_popover, {
                                                            key: 1,
                                                            effect: "dark",
                                                            trigger: "hover",
                                                            placement: "top",
                                                            width: 300,
                                                            "popper-class": "active-actions-table__column-ia-insights",
                                                            transition: "none"
                                                        }, {
                                                            reference: _withCtx(() => [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass('active-actions-table__performance active-actions-table__performance--' +
                                                                        getStatusPerformance(scope.row.performance))
                                                                }, _toDisplayString(_ctx.$t(`campaigns-management.ia-insights.status.${getStatusPerformance(scope.row.performance)}`)), 3)
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createElementVNode("p", {
                                                                    innerHTML: _ctx.$t(`campaigns-management.ia-insights.tooltips.${getStatusPerformance(scope.row.performance)}`)
                                                                }, null, 8, _hoisted_14)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true),
                                                    (column.key === 'actions')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                            _createVNode(_component_el_dropdown, {
                                                                trigger: "click",
                                                                class: "active-actions-table__dropdown"
                                                            }, {
                                                                dropdown: _withCtx(() => [
                                                                    _createVNode(_component_el_dropdown_menu, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_el_dropdown_item, {
                                                                                onClick: ($event) => (deactivateAction(scope.row))
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.$t('deactivate')), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1032, ["onClick"]),
                                                                            _createVNode(_component_el_dropdown_item, {
                                                                                onClick: ($event) => (_unref(redirectToEditActionPage)(scope.row))
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.$t('edit')), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1032, ["onClick"])
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _hoisted_16
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1032, ["prop", "label", "min-width"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }, 8, ["data", "class"]))
                                : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                                    "row-key": "id",
                                    key: "id",
                                    data: state.tableData,
                                    class: _normalizeClass(["active-actions-table__drag", { 'deactive-actions-table--blocked': !state.tableData.length }]),
                                    ref_key: "table",
                                    ref: table
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.tableHeader, (column, index) => {
                                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                                key: index,
                                                "row-key": "id",
                                                "column-key": "id",
                                                prop: column.key,
                                                label: column.label,
                                                "min-width": getColumnWidth(column.key)
                                            }, {
                                                header: _withCtx(() => [
                                                    (column.key === 'performance')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                            _createElementVNode("label", null, _toDisplayString(column.label), 1),
                                                            _createVNode(_component_el_popover, {
                                                                effect: "dark",
                                                                trigger: "hover",
                                                                placement: "top",
                                                                width: 370
                                                            }, {
                                                                reference: _withCtx(() => [
                                                                    _hoisted_19
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("p", {
                                                                        innerHTML: _ctx.$t('campaigns-management.ia-insights.tooltips.column')
                                                                    }, null, 8, _hoisted_18)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                default: _withCtx((scope) => [
                                                    (column.key === 'priority')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _hoisted_20,
                                                            _createTextVNode(" " + _toDisplayString(scope.row.priority), 1)
                                                        ], 64))
                                                        : _createCommentVNode("", true),
                                                    (column.key === 'name')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                            _createVNode(_component_router_link, {
                                                                title: scope.row.action,
                                                                to: `/campaigns/campaigns/edit/${scope.row.id}`,
                                                                class: "active-actions-table__name"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(scope.row.action), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["title", "to"]),
                                                            (shouldShowNoMessageTooltip(scope.row))
                                                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                                    key: 0,
                                                                    placement: "top",
                                                                    content: _ctx.$t('campaigns-management.active-actions.no_message'),
                                                                    "popper-class": "active-actions-table__tooltip"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("img", {
                                                                            class: "active-actions-table__no-message-icon",
                                                                            src: require(`@/assets/svgs/information.svg`)
                                                                        }, null, 8, _hoisted_22)
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["content"]))
                                                                : _createCommentVNode("", true),
                                                            (scope.row.campaignsApproval)
                                                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                                    key: 1,
                                                                    placement: "top",
                                                                    content: _ctx.$t('campaigns-management.active-actions.pending', {
                                                                        participating: scope.row.campaignsApproval.participating,
                                                                        total: scope.row.campaignsApproval.total,
                                                                    }),
                                                                    "popper-class": "active-actions-table__tooltip"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("img", {
                                                                            class: "active-actions-table__approval-icon",
                                                                            onClick: ($event) => (_unref(redirectToParticipantsPage)(scope.row)),
                                                                            src: require(`@/assets/svgs/Store.svg`),
                                                                            "data-hover": require(`@/assets/svgs/StoreOmni.svg`)
                                                                        }, null, 8, _hoisted_23)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["content"]))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (column.key === 'performance')
                                                        ? (_openBlock(), _createBlock(_component_el_popover, {
                                                            key: 2,
                                                            effect: "dark",
                                                            trigger: "hover",
                                                            placement: "top",
                                                            width: 300,
                                                            "popper-class": "active-actions-table__column-ia-insights",
                                                            transition: "none"
                                                        }, {
                                                            reference: _withCtx(() => [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass('active-actions-table__performance active-actions-table__performance--' +
                                                                        getStatusPerformance(scope.row.performance))
                                                                }, _toDisplayString(_ctx.$t(`campaigns-management.ia-insights.status.${getStatusPerformance(scope.row.performance)}`)), 3)
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createElementVNode("p", {
                                                                    innerHTML: _ctx.$t(`campaigns-management.ia-insights.tooltips.${getStatusPerformance(scope.row.performance)}`)
                                                                }, null, 8, _hoisted_24)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true),
                                                    (column.key === 'actions')
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 3,
                                                            class: _normalizeClass({ hidden: state.isEditTable })
                                                        }, [
                                                            _createVNode(_component_el_dropdown, {
                                                                trigger: "click",
                                                                class: "active-actions-table__dropdown"
                                                            }, {
                                                                dropdown: _withCtx(() => [
                                                                    _createVNode(_component_el_dropdown_menu, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_el_dropdown_item, {
                                                                                onClick: ($event) => (deactivateAction(scope.row))
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.$t('deactivate')), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1032, ["onClick"]),
                                                                            _createVNode(_component_el_dropdown_item, {
                                                                                onClick: ($event) => (_unref(redirectToEditActionPage)(scope.row))
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.$t('edit')), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1032, ["onClick"])
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _hoisted_25
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ], 2))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1032, ["prop", "label", "min-width"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }, 8, ["data", "class"])), [
                                    [_unref(vDragable), dragOptions]
                                ])
                        ], 64))
                        : (_openBlock(), _createBlock(BaseLoader, { key: 2 })),
                    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                        _createElementVNode("div", {
                            ref_key: "animationContainer",
                            ref: animationContainer,
                            class: _normalizeClass(['animation', !state.showLoadingAiInsights && 'animation__hidden'])
                        }, null, 2)
                    ]))
                ])
            ], 64));
        };
    }
});
